import React, { useState, useEffect } from "react";
import Planets from "./planets";
import ModuleHeader from "../../moduleHeader";
import { getLatestBirthChart } from "../../../services/birthChartService";
import { getCurrentPackageUserModule } from "../../../services/api";

function NatalChart({ id }) {
  const [birthChartData, setBirthChartData] = useState(null);
  const [packageData, setPackageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isHeaderExpanded, setIsHeaderExpanded] = useState(false);

  // Paket ve kullanıcı bilgilerini çek (moduleId sabit 3 - Doğum Haritası)
  useEffect(() => {
    if (!id) return;

    const fetchPackageData = async () => {
      try {
        const data = await getCurrentPackageUserModule(id, 3);
        setPackageData(data);
      } catch (error) {
        console.error("Paket verisi alınamadı:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPackageData();
  }, [id]);

  // Doğum haritası verisini çek
  useEffect(() => {
    const fetchBirthChart = async () => {
      try {
        const response = await getLatestBirthChart();
        // API'den gelen veri: { success: true, data: { birth_chart: {...}, frontend_chart: {...} } }
        if (response?.success && response?.data) {

          setBirthChartData(response.data);
        } else {
          console.error("Doğum haritası verisi beklenen formatta değil:", response);
        }
      } catch (error) {
        console.error("Doğum haritası verisi alınamadı:", error);
      }
    };

    fetchBirthChart();
  }, []);


  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [overlayInitialTab, setOverlayInitialTab] = useState("gezegenler");

  const openOverlay = (tab) => {
    setOverlayInitialTab(tab);
    setIsOverlayOpen(true);
  };

  const closeOverlay = () => setIsOverlayOpen(false);

  // Sayfa açıldığında otomatik olarak Gezegenler sekmesini göster
  useEffect(() => {
    if (!loading && birthChartData) {
      setOverlayInitialTab("gezegenler");
      setIsOverlayOpen(true);
    }
  }, [loading, birthChartData]);

  if (loading || !packageData) {
    return (
      <div className="w-full h-screen min-h-screen flex items-center justify-center bg-[#fff]">
        <div className="flex flex-col items-center justify-center">
          <div className="relative mb-8">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="animate-spin rounded-full h-24 w-24 border-4 border-transparent border-t-[#3DA7B5] border-r-[#3DA7B5] opacity-75"></div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div
                className="animate-spin rounded-full h-16 w-16 border-[3px] border-transparent border-b-[#2a8a96] border-l-[#2a8a96] opacity-60"
                style={{
                  animationDirection: "reverse",
                  animationDuration: "1.5s",
                }}
              ></div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="h-12 w-12 rounded-full bg-gradient-to-br from-[#3DA7B5] via-[#2a8a96] to-[#3DA7B5] animate-pulse shadow-2xl"></div>
            </div>
          </div>
          <p className="text-xl font-semibold text-gray-800 animate-pulse">
            Yükleniyor...
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="w-full h-screen min-h-screen flex items-stretch justify-stretch sm:items-center sm:justify-center bg-[#e8e9ed] relative">
        <div
          className="flex flex-col items-center w-full min-h-full bg-white shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative overflow-y-auto"
          style={{
            backgroundImage: "url(/assets/birthChart/birth-chart-bg.png)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          {/* ModuleHeader */}
          {packageData && (
            <ModuleHeader
              userName={
                packageData.user?.first_name + " " + packageData.user?.last_name
              }
              subtitle={packageData.package?.name + " Modülüne Hoş Geldiniz"}
              title={packageData.package?.name}
              description={packageData.package?.description}
              backgroundImage={packageData.package?.image_url}
              onExpandedChange={setIsHeaderExpanded}
            />
          )}

          <div
            className={`relative flex flex-col min-h-screen w-full text-gray-800 bg-transparent rounded-t-3xl z-20 shadow-lg overflow-hidden transition-all duration-300 ${isHeaderExpanded ? "-mt-8" : "-mt-8"
              }`}
          >
            <div className="flex flex-col items-center justify-center p-6 w-full">
              {/* İçerik buraya gelecek */}
            </div>

            {isOverlayOpen && (
              <div className="absolute inset-0 z-50 animate-fadeIn">
                <div className="absolute inset-0">
                  <Planets
                    initialTab={overlayInitialTab}
                    embedded={true}
                    onClose={closeOverlay}
                    birthChartData={birthChartData?.birth_chart}
                    frontendChart={birthChartData?.frontend_chart}
                    user={packageData?.user}
                    packageData={packageData}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default NatalChart;

